import { render, staticRenderFns } from "./AssignGroupsToCustomers.vue?vue&type=template&id=6bfb9915"
import script from "./AssignGroupsToCustomers.vue?vue&type=script&lang=js"
export * from "./AssignGroupsToCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports